<template>
  <div name="detail-template">
    <slot name="head">HEAD</slot>
    <slot name="body">BODY</slot>
  </div>
</template>

<script>
export default {
  name: 'detail-template',
  data () {
    return {
      topicDisp: true,
      detail: this.detailRow
    }
  },
  watch: {
    detailRow () {
      this.detail = this.detailRow
    }
  },
  methods: {
    toggleDisp () {
      this.topicDisp = !this.topicDisp
    },
    deleteEmit (rowIndex) {
      this.$emit('deleteTrigger', rowIndex)
    }
  },
  props: [ 'nowLang', 'labelsButton', 'labels', 'dropdowns', 'rowIndex', 'detailRow', 'constLabels' ]
}
</script>


// WEBPACK FOOTER //
// detailTemplate.vue?3e59284c